import { create, } from "zustand";
import { persist, } from "zustand/middleware";

import {
	getAccount,
	watchAccount,
	type GetAccountReturnType,
	type WatchAccountReturnType,
} from "wagmi/actions";

import {
	COUNTRY_BLACK_LIST,
	WHITE_ACCTS,
} from "./const";

import { wagmiConfig, } from "@config";
import { getLocationData, } from "./helpers";



export declare type LegalStore = {

	initialized: boolean;
	initializing: boolean;
	accepted_terms: boolean;
	scrolled_terms: boolean;
	scrolled_privacy: boolean;
	/** when true, the country is considered unservicable, access will require an open/false account lock */
	country_lock: boolean;

	country_checked: boolean;

	country: string;

	account_checked: boolean;

	/** when true, the account is considered unservicable, access will require an open/false country lock */
	account_lock: boolean;

	_onAccountChangeLsn: WatchAccountReturnType|null;

	initialize: () => Promise<void>;
	setScrolledTerms: ( scrolled_terms:boolean, ) => void;
	setScrolledPrivacy: ( scrolled_privacy:boolean, ) => void;
	setTermsAccepted: ( accepted_terms:boolean, ) => void;
	_bindListeners: () => void;
	_onAccountChange: ( acct: GetAccountReturnType, prev: GetAccountReturnType, ) => void;
	_parseConnection: ( ) => Promise<void>;
};



export const useLegalStore = create<LegalStore>()(persist((set, get,) => ({

	initialized: false,
	initializing: false,
	country_lock: true,
	country_checked: false,
	country: "",
	account_checked: false,
	account_lock: true,
	accepted_terms: false,
	scrolled_privacy: false,
	scrolled_terms: false,
	_onAccountChangeLsn: null,


	initialize: async () => {
		set({
			initializing: true,
			initialized: false,
		});
		await get()._parseConnection();
		set({
			initializing: false,
			initialized: true,
		});
	},


	setScrolledTerms: ( scrolled_terms, ) => { set({ scrolled_terms, }); },
	setScrolledPrivacy: ( scrolled_privacy, ) => { set({ scrolled_privacy, }); },
	setTermsAccepted: ( accepted_terms, ) => { set({ accepted_terms, })},


	_bindListeners: () => {
		if(get()._onAccountChangeLsn) {
			//@ts-ignore - this cant be falsy.
			get()._onAccountChangeLsn();
		}
		const _onAccountChangeLsn = watchAccount(wagmiConfig, {
			onChange: get()._onAccountChange,
		});
		set({ _onAccountChangeLsn, });
	},


	_onAccountChange: ( acct: GetAccountReturnType, prev: GetAccountReturnType, ) => {
		const { address, } = acct;
		( async () => {
			set({ account_lock: true, country_lock: true, country_checked: false, account_checked: false, });
			if( address ) {
				await get()._parseConnection();
			}
		} )();
	},


	_parseConnection: async () => {

		const { address, } = getAccount(wagmiConfig);

		let account_lock = false;
		let account_checked = false;
		let country_lock = true;
		let country_checked = false;
		let country = "unknown location";
		let postal_code = -1;

		if( address ) {

			// see if we can authenticate by account only via the white-list;
			account_lock = (
				!(WHITE_ACCTS.includes(address.toLocaleLowerCase())) &&
				!window.location.host.startsWith('localhost')
			);
			account_checked = true;

			const result = await getLocationData(address);
			const country_code = result["CloudFront-Viewer-Country"];

			if(!country_code)
				throw new Error("cloudfront failed to populate CloudFront-Viewer-Country param");

			country_lock = COUNTRY_BLACK_LIST.includes(country_code);
			country_checked = true;
			country = result["CloudFront-Viewer-Country-Name"];
			postal_code = result["CloudFront-Viewer-Postal-Code"] ? Number.parseInt(result["CloudFront-Viewer-Postal-Code"]) : -1;

			if(country_code === "UA" && ((postal_code >= 83000 && postal_code <= 87999) || (postal_code >= 91 && postal_code <= 95))) {
				country_lock = true;
			}

			set({
				country_checked,
				country_lock,
				account_lock,
				country,
				account_checked,
			});

		}

	}


}), {
	name: "legal",
	onRehydrateStorage: (state) => {
		return ( state, error, ) => {
			// console.log("LegalStore:: rehydro");
			if( error ) {
				console.log('an error happened during hydration', error)
			} else {
				if( state ) {
					state.initialized = false;
					state.initializing = false;
					state._bindListeners();
				}
			}
		};
	},
}));

